import { SELECT_TITLE } from "./actions"; 
import frame from "./assets/Frame.png"

const initialState = {
  networks: [
    {
      id: 1,
      title: "Ethereum",
      network: "Destination",
      image: frame,
    },
    {
      id: 2,
      title: "Arbitrum",
      network: "Destination Network",
      image: frame,
    },
    {
      id: 3,
      title: "Optimism",
      network: "Destination Network",
      image: frame,
    },
    {
      id: 4,
      title: "Polygon",
      network: "Destination Network",
      image: frame,
    },
    {
      id: 5,
      title: "Base",
      network: "Destination Network",
      image: frame,
    },
    {
      id: 6,
      title: "Celo",
      network: "Destination Network",
      image: frame,
    },
  ],
  selectedTitle: null,
};


const reducer = (state = initialState, action: { type: any; payload: any; }) => {
  switch (action.type) {
    case SELECT_TITLE:
      return {
        ...state,
        selectedTitle: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
